/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ReactElement, useEffect, useState } from 'react';
import './MatchedVisasDashboard-Desktop.scss';
import FlagSwitcher from 'components/common/MatchedVisasSideBar/flagSwitcher';

type MatchedVisasItemProps = {
    countryVisaData: any;
    isAssessmentScoreEmpty?: boolean;
    paid?: boolean;
};

function MatchedVisasItemDesktop({
    countryVisaData,
    isAssessmentScoreEmpty,
    paid,
}: MatchedVisasItemProps): ReactElement | null {
    const initialWidth = () => {
        if (window.innerWidth <= 767) {
            return '30';
        }
        if (window.innerWidth > 767 && window.innerWidth <= 1028) {
            return '35';
        }
        if (window.innerWidth > 1028) {
            return '40';
        }
    };
    const initialHeight = () => {
        if (window.innerWidth <= 767) {
            return '20';
        }
        if (window.innerWidth > 767 && window.innerWidth <= 1028) {
            return '25';
        }
        if (window.innerWidth > 1028) {
            return '30';
        }
    };
    const [isNumberThere, setIsNumberThere] = useState<boolean>(false);
    const [width, setWidth] = useState(initialWidth());
    const [height, setHeight] = useState(initialHeight());

    const trueScore = (item: any): number => {
        const score: number = Math.round((100 * item.summary.score) / item.summary.max_score);

        if (isNaN(score)) {
            return 70;
        }
        return score;
    };
    const scoreLevel = (score: number) =>
        score < 50 ? 'lowScore' : score < 71 ? 'mediumScore' : 'highScore';

    const sortedItems = [...countryVisaData.eligible_programs].sort((a, b) => {
        if (trueScore(a) < trueScore(b)) {
            return 1;
        } else if (trueScore(a) > trueScore(b)) {
            return -1;
        } else {
            return 0;
        }
    });

    useEffect(() => {
        const score = trueScore(sortedItems[0]);
        setIsNumberThere(score !== Infinity);
    }, [sortedItems]);

    useEffect(() => {
        const score = trueScore(sortedItems[0]);
        setIsNumberThere(score !== Infinity);
    }, [sortedItems]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 767) {
                setWidth('30');
                setHeight('20');
            }
            if (window.innerWidth > 767 && window.innerWidth <= 1028) {
                setWidth('35');
                setHeight('25');
            }
            if (window.innerWidth > 1028) {
                setWidth('40');
                setHeight('30');
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={'MatchedVisasItemWrapper'}>
            <div className={'countryWrapperDesktop'}>
                <div className={'countryFlag'}>
                    <FlagSwitcher country={countryVisaData.country} width={width} height={height} />
                </div>
                <div className={'countryName'}>{countryVisaData.country}</div>
            </div>
            <div className="MatchedVisasItemResults">
                {sortedItems.slice(0, 3).map((item: any, index: number) => (
                    <div className="MatchedVisasItemResult" key={index}>
                        <div className="visaResultBody">
                            <div className="visaResultText">
                                {item.program_name.split(' - Subclass')[0]}
                            </div>
                            <div
                                className={`visaResultScore ${scoreLevel(trueScore(item))}`}
                                style={{ filter: isNumberThere && paid ? 'none' : 'blur(6px)' }}
                            >
                                {`${trueScore(item)}%`}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MatchedVisasItemDesktop;
